{
  "$schema": "https://mux.run/theme.json",
  "name": "Dracula",
  "id": "dracula",
  "light": {
    "palette": {
      "neutral": "#f8f8f2",
      "ink": "#1f1f2f",
      "primary": "#7c6bf5",
      "accent": "#d16090",
      "success": "#2fbf71",
      "warning": "#f7a14d",
      "error": "#d9536f",
      "info": "#1d7fc5",
      "diffAdd": "#9fe3b3",
      "diffDelete": "#f8a1b8"
    },
    "overrides": {
      "syntax-comment": "#7d7f97",
      "syntax-keyword": "#d16090",
      "syntax-string": "#596600",
      "syntax-primitive": "#2f8f57",
      "syntax-property": "#1d7fc5",
      "syntax-constant": "#7c6bf5"
    }
  },
  "dark": {
    "palette": {
      "neutral": "#1d1e28",
      "ink": "#f8f8f2",
      "primary": "#bd93f9",
      "accent": "#ff79c6",
      "success": "#50fa7b",
      "warning": "#ffb86c",
      "error": "#ff5555",
      "info": "#8be9fd",
      "diffAdd": "#2fb27d",
      "diffDelete": "#ff6b81"
    },
    "overrides": {
      "syntax-comment": "#6272a4",
      "syntax-keyword": "#ff79c6",
      "syntax-string": "#f1fa8c",
      "syntax-primitive": "#50fa7b",
      "syntax-property": "#8be9fd",
      "syntax-constant": "#bd93f9"
    }
  }
}
